import styled, { css } from 'styled-components'

import { Skeleton as Skeleton_ } from '@blade/ui-kit'

import { PremiumListItemRoot } from '../common/premium-list-item'

import type { ClassNameProps } from '@root/shared/react'

type ExpiredPremiumListItemSkeletonProps = {
  disabled?: boolean
} & ClassNameProps

export const ExpiredPremiumListItemSkeleton: React.FC<
  ExpiredPremiumListItemSkeletonProps
> = ({ disabled = false, className }) => (
  <Root aria-disabled={disabled} className={className}>
    <Start>
      <Icon>
        <SkeletonDisabled height={38} width={38} variant="circular" />
        <SkeletonDisabled
          height={12}
          width={12}
          variant="circular"
          css={css`
            position: absolute;
            bottom: 2px;
            right: 0;
            background: var(--background-4);
            border-radius: 50%;
          `}
        />
      </Icon>
      <Group>
        <Row
          css={css`
            width: 80%;
            grid-template-columns: 1.2fr 0.8fr 1.5fr;
          `}
        >
          <Skeleton height={14} />
          <Skeleton height={14} />
          <Skeleton height={14} />
        </Row>
        <Row
          css={css`
            width: 80%;
            grid-template-columns: 0.6fr 1fr 1fr 0.4fr;
          `}
        >
          <Skeleton height={12} />
          <Skeleton height={12} />
          <Skeleton height={12} />
        </Row>
      </Group>
    </Start>
    <Middle>
      <Skeleton height={10} />
    </Middle>
    <End>
      <SkeletonRounded
        width={105}
        height={30}
        css={css`
          opacity: 0.5;
        `}
      />
    </End>
  </Root>
)

const Root = styled(PremiumListItemRoot)`
  grid-template-columns: minmax(0, 1fr) 300px minmax(0, 1fr);
`

const Middle = styled.div`
  background: var(--background-4);
  height: 40px;

  display: grid;
  justify-items: center;
  padding-inline: 12px;
  align-items: center;
  border-radius: 6px;
`

const Start = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;

  align-items: center;

  padding-inline: 15px;
  gap: 10px;
`

const Group = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  gap: 6px;
`

const End = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto auto;
  justify-content: end;
  padding-inline-end: 16px;
`

const Icon = styled.div`
  border-radius: 50%;
  position: relative;
`

const SkeletonDisabled = styled(Skeleton_)`
  ${Root}[aria-disabled='true'] & {
    > div:after {
      animation: none;
    }
  }
`

const Skeleton = styled(SkeletonDisabled)`
  > div {
    border-radius: 3px;
  }
`

const SkeletonRounded = styled(SkeletonDisabled)`
  > div {
    border-radius: 6px;
  }
`

const Row = styled.div`
  display: grid;
  grid-auto-flow: column;

  gap: 8px;
`
